"use strict";
document.addEventListener('DOMContentLoaded', () => {
    const notificationsUnreadPanelHeader = document.querySelector('#notifications-unread-panel-header');
    const notificationsReadPanelHeader = document.querySelector('#notifications-read-panel-header');
    if (notificationsUnreadPanelHeader) {
        let unreadListVisible = true;
        let unreadListArrowDownVisible = false;
        let unreadListArrowUpVisible = true;
        notificationsUnreadPanelHeader.addEventListener('click', () => {
            unreadListVisible = !unreadListVisible;
            unreadListArrowDownVisible = !unreadListArrowDownVisible;
            unreadListArrowUpVisible = !unreadListArrowUpVisible;
            toggle(document.querySelector('#notifications-unread-list'), unreadListVisible);
            toggle(document.querySelector('#notifications-unread-caret-down'), unreadListArrowDownVisible);
            toggle(document.querySelector('#notifications-unread-caret-up'), unreadListArrowUpVisible);
        });
    }
    if (notificationsReadPanelHeader) {
        let readListVisible = true;
        let readListArrowDownVisible = false;
        let readListArrowUpVisible = true;
        notificationsReadPanelHeader.addEventListener('click', () => {
            readListVisible = !readListVisible;
            readListArrowDownVisible = !readListArrowDownVisible;
            readListArrowUpVisible = !readListArrowUpVisible;
            toggle(document.querySelector('#notifications-read-list'), readListVisible);
            toggle(document.querySelector('#notifications-read-caret-down'), readListArrowDownVisible);
            toggle(document.querySelector('#notifications-read-caret-up'), readListArrowUpVisible);
        });
    }
    function toggle(el, isVisible) {
        if (!isVisible) {
            el.style.display = 'none';
        }
        else {
            el.style.display = 'block';
        }
    }
});
